import React, { useContext } from 'react';
import PropTypes from 'prop-types';

// Components
import { ButtonPrimaryLarge, LinkSmall, Ul } from '@styled';

// Functionality
import { GlobalModalContext } from '@context/globalModalContext';
import styled from 'styled-components';

const ListItem = styled.li`
    padding: 5px 0;
    font-size: 14px;
`;

const ulStyles = {
    maxHeight: '150px',
    minHeight: '100px',
    overflowY: 'scroll',
};

export const usePropertyViewsModal = () => {
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const openModal = ({ uniqueViews }) => {
        setModalChildren(() => <PropertyViewsModal uniqueViews={uniqueViews} />);

        setIsModalOpen(true);
    };

    return { openModal };
};

const PropertyViewsModal = props => {
    const { uniqueViews } = props;

    const [, setIsModalOpen] = useContext(GlobalModalContext);

    return (
        <>
            <div>
                <h2 className="font-weight-bold">Views</h2>
                {uniqueViews.length > 0 && (
                    <Ul className="my-4" style={ulStyles}>
                        {uniqueViews.map((view, index) => (
                            <ListItem key={index}>
                                <div className="flex">
                                    <LinkSmall href={`/member/profile/${view.recordId}`} target="_blank">
                                        {view.firstName} {view.lastName} - Views ({view.count})
                                    </LinkSmall>
                                </div>
                            </ListItem>
                        ))}
                    </Ul>
                )}
                <ButtonPrimaryLarge onClick={() => setIsModalOpen(false)}>Close</ButtonPrimaryLarge>
            </div>
        </>
    );
};

PropertyViewsModal.propTypes = {
    uniqueViews: PropTypes.array,
};

export default PropertyViewsModal;
